import { type OpenApiSchemaIntegrationType } from '../../api/schema';
import { INTEGRATION_TYPE_EXCEL, INTEGRATION_TYPE_NONE } from './constants';
import { type SupportedIntegrationTypes } from './types';

export const isSupportedIntegrationType = (
    type: OpenApiSchemaIntegrationType | undefined
): type is SupportedIntegrationTypes => type !== INTEGRATION_TYPE_NONE && type !== INTEGRATION_TYPE_EXCEL;
